import React, { useEffect } from 'react';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonIcon,
  IonLabel,
  IonButton,
  IonAvatar,
  IonRow,
  IonCol,
  IonImg,
  IonSlide,
  IonButtons,
  IonGrid,
} from '@ionic/react';
import { home } from 'ionicons/icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getProfile } from '../actions/profile';
import { getPosts } from '../actions/post';

const logout = () => {
  localStorage.removeItem('token');
  window.location = '/home';
};

const Profile = ({ getProfile, getPosts, auth, profile: { profile }, post: { posts } }) => {
  useEffect(() => {
    getProfile();
    getPosts();
    // eslint-disable-next-line
  }, []);

  const pp =
    posts &&
    posts.filter((post) => {
      return post.user.includes(profile && profile._id);
    });
  let ll = 0;
  pp.map((post) => (ll += post.noOflikes));

  return (
    <IonContent>
      <IonHeader>
        <IonToolbar color='secondary' style={{ padding: '0 5px' }}>
          <IonButtons slot='start'>
            <IonButton href='/dash'>
              <IonIcon slot='icon-only' icon={home} size='small' />
            </IonButton>
          </IonButtons>
          <IonButton size='small' color='tertiary' slot='end' href='/profile/edit'>
            Edit
          </IonButton>
          <IonButton size='small' color='danger' slot='end' onClick={logout}>
            Log Out
          </IonButton>
          <IonTitle>
            <h5 className='title'>Profile</h5>
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonSlide>
          <IonCol>
            <IonCardHeader>
              <IonRow className='ion-justify-content-center ion-align-items-center ion-padding'>
                <IonAvatar style={{ height: '150px', width: '150px' }}>
                  <IonImg src={profile && profile.avatar} />
                </IonAvatar>
              </IonRow>

              <IonRow className='ion-justify-content-center ion-align-items-center ion-padding'>
                <IonLabel>
                  <h1>
                    <strong>{profile && profile.name}</strong>
                  </h1>
                  <h2>
                    <strong>{profile && profile.username}</strong>
                  </h2>
                </IonLabel>
              </IonRow>

              <IonCardContent>
                <h2>{profile && profile.bio}</h2>
              </IonCardContent>
              <IonGrid>
                <IonRow className='ion-justify-content-center ion-align-items-center ion-padding ion-text-center'>
                  <IonCol sizeMd='3'>
                    <IonCard color='primary'>
                      <IonRow className='ion-justify-content-center ion-align-items-center ion-padding-top ion-padding-horizontal'>
                        <h4>Posts</h4>
                      </IonRow>
                      <IonRow className='ion-justify-content-center ion-align-items-center ion-padding'>
                        <h1>{pp.length}</h1>
                      </IonRow>
                    </IonCard>
                  </IonCol>

                  <IonCol sizeMd='3'>
                    <IonCard color='primary'>
                      <IonRow className='ion-justify-content-center ion-align-items-center ion-padding-top ion-padding-horizontal'>
                        <h4>Likes</h4>
                      </IonRow>
                      <IonRow className='ion-justify-content-center ion-align-items-center ion-padding'>
                        <h1>{ll}</h1>
                      </IonRow>
                    </IonCard>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCardHeader>
          </IonCol>
        </IonSlide>
      </IonContent>
    </IonContent>
  );
};

Profile.propTypes = {
  getProfile: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.register,
  profile: state.profile,
  post: state.post,
});

export default connect(mapStateToProps, { getProfile, getPosts })(Profile);
